import type { ClockSize } from '../hooks/useDisplaySettings';

/**
 * Shared styling for the two "device is idle" faces: the Screensaver in
 * clock-only mode and the SleepOverlay with no photos.
 *
 * Both used to be near-black with grey text, which residents read as "the
 * tablet is broken / off" rather than "asleep". A lifted background plus
 * full-white glyphs keeps them unmistakably powered on while still being
 * calm enough for a dark room.
 */
export const STANDBY_BACKGROUND =
  'radial-gradient(ellipse at 50% 45%, #23262d 0%, #101216 55%, #050608 100%)';

export const CLOCK_FONT_STACK =
  '"Segoe UI Variable Display", "Segoe UI", system-ui, -apple-system, "Helvetica Neue", sans-serif';

export const CLOCK_GLOW = '0 0 32px rgba(255,255,255,0.32), 0 2px 6px rgba(0,0,0,0.55)';
export const DATE_GLOW = '0 0 18px rgba(255,255,255,0.18)';

export const CLOCK_FONT_SIZES: Record<ClockSize, number> = {
  small: 56,
  medium: 120,
  large: 200,
};

export const ANALOG_CLOCK_SIZES: Record<ClockSize, number> = {
  small: 160,
  medium: 280,
  large: 420,
};

export const DATE_FONT_SIZES: Record<ClockSize, number> = {
  small: 20,
  medium: 32,
  large: 46,
};
